import { BookingScheduleInterface } from "../../Booking-Form/typings/booking.types";
import { isConferenceVisitorRegistrationRow } from "./visitor-bookings-table.partial";
import type { VisitorBookingTableRow } from "./visitor-bookings-table.partial";

export type VisitorReceptionTarget =
  | { kind: "place"; visitId: number }
  | { kind: "conference"; visitorRegistrationId: number };

export type VisitorAdminBulkRejectItem =
  | { kind: "place"; visitId: number }
  | { kind: "conference"; visitorRegistrationId: number };

export function resolveVisitorReceptionTarget(
  row: Pick<BookingScheduleInterface, "id" | "bookingType" | "visitorRegistrationId">
): VisitorReceptionTarget | null {
  if (isConferenceVisitorRegistrationRow(row)) {
    const visitorRegistrationId = row.visitorRegistrationId ?? row.id;
    if (!Number.isFinite(visitorRegistrationId) || visitorRegistrationId <= 0) {
      return null;
    }
    return { kind: "conference", visitorRegistrationId };
  }

  const visitId = row.id;
  if (!Number.isFinite(visitId) || visitId <= 0) {
    return null;
  }
  return { kind: "place", visitId };
}

export function buildVisitorAdminBulkRejectItems(
  rows: VisitorBookingTableRow[]
): VisitorAdminBulkRejectItem[] {
  const items: VisitorAdminBulkRejectItem[] = [];

  for (const row of rows) {
    const target = resolveVisitorReceptionTarget(row);
    if (!target) {
      continue;
    }
    if (target.kind === "place") {
      items.push({ kind: "place", visitId: target.visitId });
    } else {
      items.push({
        kind: "conference",
        visitorRegistrationId: target.visitorRegistrationId
      });
    }
  }

  return items;
}

export function visitorReceptionTargetToBulkRejectItem(
  target: VisitorReceptionTarget
): VisitorAdminBulkRejectItem {
  if (target.kind === "place") {
    return { kind: "place", visitId: target.visitId };
  }
  return {
    kind: "conference",
    visitorRegistrationId: target.visitorRegistrationId
  };
}
